<template>
  <div class="resume-preview-wrapper">
    <ResumePdf mode="pdf" />
  </div>
</template>
<script>
import ResumePdf from '@/views/editor2025/components/ResumePreview/resume.vue';
export default {
  name: 'ResumePdfPage',
  components: {
    ResumePdf,
  },
  data() {
    return {
      resume: {},
      loadingVisible: true,
    };
  },
  methods: {
    calcResumeWidth() {
      const MAX_WIDTH = 720;
      const MIN_WIDTH = 570;
      const bodyWidth = document.body.offsetWidth;
      // 666 是编辑器宽度，22 是编辑器和简历之间的间距
      const surplus = bodyWidth - 666 - 22;
      const resumeWidth = Math.min(Math.max(surplus, MIN_WIDTH), MAX_WIDTH);
      this.$store.commit('editor/setResumeWidthByValue', resumeWidth);
    },
    initResumeData() {
      const cv = window.localStorage.getItem('wonderResume');
      if (cv && typeof cv === 'string') {
        const resume = JSON.parse(cv);
        this.$store.commit('editor/setCvDetail', {
          basic_info: resume.basic_info,
          submodule_info: resume.submodule_info,
          format_info: resume.format_info,
        });
        this.$store.commit('editor/setProfileData', resume.profile);
        ['works', 'edus', 'orgs', 'opus'].forEach((type) => {
          this.$store.commit('editor/setModuleData', {
            type,
            info: resume[type] || [],
          });
        });
        resume.custom_sections?.forEach((item) => {
          this.$store.commit('editor/setModuleData', {
            type: item.category === 'custom' || !item.category ? item.id : item.category,
            info: item.infos || [],
          });
        });
        this.$store.commit('editor/setExtrasData', resume.others || {});

        this.loadingVisible = false;
      }
    },
  },
  mounted() {
    this.calcResumeWidth();
    this.initResumeData();
  },
};
</script>
<style lang="scss" scoped>
.resume-preview-wrapper {
  flex: 1;
  min-width: 540px;
  max-width: 720px;
  max-height: 100%;
  margin: 0 auto;
  padding-top: 24px;
  overflow-y: scroll;
  padding-bottom: 24px;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
